import React, { lazy, Suspense } from "react";
const HeadingsPanelController = lazy(
  () => import("./headings-dropdown.js").then(({ default: HeadingsDropdown }) => ({
    default: HeadingsDropdown
  }))
);
const HeadingPanelComponent = (suspenseWidth) => (props) => /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", { style: { width: suspenseWidth } }) }, /* @__PURE__ */ React.createElement(HeadingsPanelController, { ...props, minWidth: suspenseWidth }));
var headings_dropdown_lazy_default = HeadingPanelComponent;
export {
  headings_dropdown_lazy_default as default
};
//# sourceMappingURL=headings-dropdown-lazy.js.map
